import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { ChannelMemberUserTypeEnum } from '@src/enum/ChannelMemberUserTypeEnum';

export type ChatReaction = {
  emoji: string;
  count: number;
  is_reacted: boolean;
  users: {
    user_id?: number;
    display_name?: string;
    user_type?: ChannelMemberUserTypeEnum;
    avatar_url?: string;
  }[];
};

export type ChatReactionPostRequest = {
  emoji: string;
};

export type ChatReactionPostResponse = ChatReaction;

export const chatReactionApiClient = {
  post: async (
    channelCode: string,
    chatId: number,
    params: ChatReactionPostRequest,
  ): Promise<ApiResult<ChatReactionPostResponse>> => {
    return await axiosClient.post(
      `/community/channels/${channelCode}/chats/${chatId}/reactions`,
      params,
    );
  },
};
